import { useEffect, useRef } from 'react';

import { useCampaignTracking } from '#src/app/shared/hooks/campaignTracking';

import { useUserRecordingCapability } from './useUserRecordingCapability';

/**
 * Fires `action_page_view` for the video ask, once per mount and only after the viewer's recording
 * capability has resolved, so `login_prompt` and `recording_capability` are never reported as loading.
 *
 * Shared by every screen that stands in for the video ask - today's invite and R2's static-faces ask
 * (CHANGE-99359) - so the "viewed the supporter voices page" funnel step counts each arm the same way.
 * A screen that stands in for the ask but skips this hook is invisible to that step.
 */
export function useTrackVideoAskView(): void {
	const capability = useUserRecordingCapability();
	const { track } = useCampaignTracking();

	const wasTrackedRef = useRef(false);

	useEffect(() => {
		if (wasTrackedRef.current || capability === 'loading') {
			return;
		}

		track('action_page_view', {
			action_type: 'voice_video',
			login_prompt: capability === 'guest-login',
			recording_capability: capability,
		});
		wasTrackedRef.current = true;
	}, [track, capability]);
}
